(function () {
  function isOpen(lb) {
    return lb && lb.classList.contains("is-open");
  }

  function openLightbox(root, src, alt, caption) {
    const lb = root.querySelector("[data-ug-lightbox]");
    if (!lb) return;

    const img = lb.querySelector("[data-ug-img]");
    const cap = lb.querySelector("[data-ug-caption]");

    // 画像
    if (img) {
      img.src = src;
      img.alt = alt || "";
    }

    // キャプション（空なら非表示）
    const capText = (caption || "").trim();
    if (cap) {
      if (capText) {
        cap.textContent = capText;
        cap.style.display = "";
      } else {
        cap.textContent = "";
        cap.style.display = "none";
      }
    }

    lb.classList.add("is-open");
    lb.setAttribute("aria-hidden", "false");

    // スクロール抑止（簡易）
    document.documentElement.classList.add("ug-lock");
  }

  function closeLightbox(root) {
    const lb = root.querySelector("[data-ug-lightbox]");
    if (!lb) return;

    const img = lb.querySelector("[data-ug-img]");
    const cap = lb.querySelector("[data-ug-caption]");

    if (img) img.removeAttribute("src");

    if (cap) {
      cap.textContent = "";
      cap.style.display = "none";
    }

    lb.classList.remove("is-open");
    lb.setAttribute("aria-hidden", "true");

    document.documentElement.classList.remove("ug-lock");
  }

  document.addEventListener("click", function (e) {
    // open
    const openBtn = e.target.closest("[data-ug-open]");
    if (openBtn) {
      const root = openBtn.closest("[data-ug]");
      if (!root) return;

      const src = openBtn.getAttribute("data-ug-src");
      const alt = openBtn.getAttribute("data-ug-alt");
      const caption = openBtn.getAttribute("data-ug-caption");

      openLightbox(root, src, alt, caption);
      return;
    }

    // close (×ボタン、背面ボタンなど data-ug-close)
    const closeBtn = e.target.closest("[data-ug-close]");
    if (closeBtn) {
      const root = closeBtn.closest("[data-ug]");
      if (!root) return;
      closeLightbox(root);
      return;
    }

    // overlay click close:
    // モーダルが開いている時、画像（figure）の外側をクリックしたら閉じる
    const lb = e.target.closest("[data-ug-lightbox]");
    if (lb && isOpen(lb)) {
      // パネル内（白い枠）のクリックは無視
      const panel = e.target.closest(".usage-gallery__lb-panel");
      if (panel) {
        // ただし「figureの外（パネルの余白）」をクリックしたら閉じたい場合
        // → figureに含まれていないなら閉じる
        const figure = e.target.closest(".usage-gallery__lb-figure");
        if (!figure) {
          const root = lb.closest("[data-ug]");
          if (root) closeLightbox(root);
        }
      } else {
        // パネル外（本当のオーバーレイ）なら閉じる
        const root = lb.closest("[data-ug]");
        if (root) closeLightbox(root);
      }
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;

    document.querySelectorAll("[data-ug]").forEach((root) => {
      const lb = root.querySelector("[data-ug-lightbox]");
      if (lb && isOpen(lb)) closeLightbox(root);
    });
  });

  // scroll lock
  const style = document.createElement("style");
  style.textContent = "html.ug-lock, html.ug-lock body { overflow: hidden; }";
  document.head.appendChild(style);
})();